import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { Fields, Columns } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS, FormValues } from '../Form/Form.types';
import { Props } from './ApplicantDetails.types';
import { getIsRetired } from '../Form/Form';
import get from 'get-value';

const ApplicantDetails: React.FC<Props> = ({ prefix, genders, lifeStages, maritalStatus }) => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  const getName = (field: FIELDS): string => {
    return `${prefix}.${field}`;
  };

  const getValue = (field: FIELDS): any => {
    return get(values, getName(field));
  };

  const isRetired = getIsRetired(values, prefix);

  useEffect(() => {
    if (isRetired) {
      // reset future income
      setFieldValue(`${prefix}.futureIncome.${FIELDS.MIN_MONTHLY_TAXABLE_RETIRED_INCOME}`, 0);
      setFieldValue(`${prefix}.futureIncome.${FIELDS.HAS_TAXABLE_INCOME_CONTINUING}`, false);
      setFieldValue(`${prefix}.futureIncome.${FIELDS.MIN_MONTHLY_TAX_FREE_RETIRED_INCOME}`, 0);
      setFieldValue(`${prefix}.futureIncome.${FIELDS.HAS_TAX_FREE_INCOME_CONTINUING}`, false);

      // reset future pension
      setFieldValue(`${prefix}.futurePension.${FIELDS.STATE_PENSION}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.DEFINED_BENEFIT}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_BENEFIT}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_BENEFIT}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.USE_OF_FUNDS}`, null);
      setFieldValue(`${prefix}.futurePension.${FIELDS.DEFINED_CONTRIBUTION}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.ONGOING_CONTRIBUTIONS}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_CONTRIBUTION}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.LUMP_SUM_DRAWDOWN}`, 0);
      setFieldValue(`${prefix}.futurePension.${FIELDS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_CONTRIBUTION}`, 0);

      // reset life events field
      setFieldValue(`${prefix}.lifeEvents.${FIELDS.VALUE_OF_ASSET_AT_RETIREMENT}`, 0);
    }
  }, [isRetired, prefix, setFieldValue]);

  return (
    <>
      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.APPLICANT_DATE_OF_BIRTH}
          name={getName(FIELDS.APPLICANT_DATE_OF_BIRTH)}
          variant={VARIANTS_TYPES.DATE}
        />
        <Field
          component={Fields.Select}
          title={FIELDS_QUESTIONS.APPLICANT_GENDER}
          name={getName(FIELDS.APPLICANT_GENDER)}
          options={genders}
          required
        />
      </Columns>
      <Columns spacing={4}>
        <Field
          component={Fields.Select}
          title={FIELDS_QUESTIONS.APPLICANT_MARITAL_STATUS}
          name={getName(FIELDS.APPLICANT_MARITAL_STATUS)}
          options={maritalStatus}
          required
        />

        <Field
          component={Fields.Select}
          title={FIELDS_QUESTIONS.APPLICANT_LIFE_STAGE}
          name={getName(FIELDS.APPLICANT_LIFE_STAGE)}
          options={lifeStages}
          required
        />
      </Columns>
      <Columns spacing={4}>
        {getValue(FIELDS.APPLICANT_LIFE_STAGE) === 'NOT_RETIRED' ? (
          <Field
            component={Fields.Text}
            title={FIELDS_QUESTIONS.APPLICANT_RETIREMENT_AGE}
            name={getName(FIELDS.APPLICANT_RETIREMENT_AGE)}
            variant={VARIANTS_TYPES.NUMBER}
          />
        ) : (
          <></>
        )}
        <></>
      </Columns>
    </>
  );
};

export default ApplicantDetails;
